// extracted by mini-css-extract-plugin
export default {"root":"binder_root__gZcwh","open":"binder_open__cuU6M","close":"binder_close__EUUod"};